import type { CSSProperties } from 'react';
import { FormattedNumber } from 'react-intl';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { Percentage } from '@sorare/core/src/atoms/icons/Percentage';
import { BrandXS } from '@sorare/core/src/atoms/typography';
import { findThresholdColor } from '@sorare/core/src/lib/thresholds';
import { css } from '@sorare/css';

const bar = css`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: calc(var(--half-unit) / 2);
  padding: calc(var(--half-unit) / 2) var(--half-unit);
  border-radius: 4px;
  background: linear-gradient(
    to right,
    transparent,
    color-mix(in srgb, var(--odds-color) 32%, transparent)
  );
`;

type Props = {
  winOddsBasisPoints: number;
};

export const TeamWinOdds = ({ winOddsBasisPoints }: Props) => {
  const percentage = winOddsBasisPoints / 100;
  const { color } = findThresholdColor(percentage, Sport.FOOTBALL);

  return (
    <div className={bar} style={{ '--odds-color': color } as CSSProperties}>
      <BrandXS bold color={color}>
        <FormattedNumber value={percentage} maximumFractionDigits={0} />
      </BrandXS>
      <Percentage color={color} />
    </div>
  );
};
